import {AfterViewInit, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BaseApiService} from "../../../../common/services/base-api-service";
import {Customer} from "../../../../common/interfaces/Customer";
import {FormGroup, Validators} from "@angular/forms";
import {FieldType} from "../customer-profile.component";
import {CustomerApi} from "../../../../common/apis/customer-api";
import {InputType} from "../../../../common/components/input/enum/InputType";
import {validatePassword} from "../../../../common/utilities/CustomValidator";

@Component({
  selector: 'app-change-info-dialog',
  templateUrl: './change-info-dialog.component.html',
  styleUrls: ['./change-info-dialog.component.scss']
})
export class ChangeInfoDialogComponent implements AfterViewInit {

  customer: Customer | null = null
  formGroup: FormGroup = new FormGroup({})
  protected readonly Validators = Validators
  loading = false
  submit = $localize`:@@submitLabel:Submit`
  serverErrorMessage: string | null = null
  protected readonly InputType = InputType;
  nameLabel: string = $localize`:@@nameLabel:Name`
  mobileNumberLabel: string = $localize`:@@contactUsMobileNumber:Mobile Number`
  confirmPasswordLabel: string = $localize`:@@confirmPassword:Confirm Password`
  currentPasswordLabel: string = $localize`:@@currentPassword:Current Password`
  createNewPasswordLabel: string = $localize`:@@merchantCreateNewPasswordTitle:Create New Password`

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string, fieldType: FieldType },
    private dialogRef: MatDialogRef<ChangeInfoDialogComponent>,
    private baseApiService: BaseApiService,
    private customerApi: CustomerApi
  ) {
  }

  ngAfterViewInit(): void {
    let customer = this.baseApiService.getJwt()?.customer
    if (customer) {
      this.customer = customer
    }
    if (this.data.fieldType === "name") {
      this.formGroup.get('inputField')?.setValue(customer?.name)
    } else if (this.data.fieldType === "mobile") {
      this.formGroup.get('inputField')?.setValue(customer?.phoneNumber)
    }
  }

  closeDialog() {
    this.dialogRef.close()
  }

  updateInfo() {
    let updatedCustomer: Customer
    if (this.data.fieldType === "password") {
      this.updatePassword()
      return
    }
    if (this.data.fieldType === "name") {
      updatedCustomer = Object.assign({}, this.customer, {name: this.formGroup.get('inputField')?.value})
    } else if (this.data.fieldType === "mobile") {
      updatedCustomer = Object.assign({}, this.customer, {phoneNumber: this.formGroup.get('inputField')?.value})
    }
    this.loading = true
    this.customerApi.updateCustomerInfo(updatedCustomer!).subscribe({
      next: (_) => {
        this.baseApiService.saveJWTToken(Object.assign({}, this.baseApiService.getJwt(), {customer: updatedCustomer}))
        this.dialogRef.close()
      },
      error: (error) => {
        this.loading = false
        this.serverErrorMessage = null
        console.log(error)
        if (Array.isArray(error)) {
          //TODO Set error message here
        }
      }
    })
  }

  private updatePassword() {
    let oldPassword = localStorage.getItem("password")
    let inputPassword = this.formGroup.get("oldPassword")?.value
    let newPassword = this.formGroup.get('newPassword')?.value
    let confirmPassword = this.formGroup.get('confirmPassword')?.value
    if (oldPassword !== inputPassword) {
      this.formGroup.get("oldPassword")?.setErrors({invalid: "Password doesn't match"})
      return
    } else if (newPassword !== confirmPassword) {
      this.formGroup.get("confirmPassword")?.setErrors({missMatch: "Passwords do not match"})
      return
    } else {
      this.loading = true
      this.customerApi.changePassword(inputPassword, newPassword).subscribe({
        next: (_) => {
          this.loading = false
          localStorage.setItem("password", newPassword)
          this.dialogRef.close()
        },
        error: (error) => {
          this.loading = false
          this.serverErrorMessage = null
          console.log(error)
          if (Array.isArray(error)) {
            //TODO Set error message here
          }
        }
      })
    }
  }

  protected readonly validatePassword = validatePassword;
}
